var _rect, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "#E0E0E0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.21777,
    y1: 9.4375,
    x2: 23.783,
    y2: 9.4375,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 11.4355,
    y1: 14.6562,
    x2: 23.7834,
    y2: 14.6562,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.3486,
    y1: 19.875,
    x2: 23.7834,
    y2: 19.875,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailDisabledIcon);
export default __webpack_public_path__ + "static/media/detail-disabled-icon.65fec4e2d33f9633c3b3c119b3d84391.svg";
export { ForwardRef as ReactComponent };